export var EVENTS = {
	RECORD_SAVED: 'RECORD_SAVED',
	RECORD_DELETED: 'RECORD_DELETED'
}